export enum ThreadTopic {
  Sales = 1,
  Manager = 2,
  ACC = 3,
  Debt = 4,
}
